export const removeDiacritics = (string) => {
  let _string = string.normalize('NFD')
  _string = _string.replace(/[\u0300-\u036f]/g, '')

  return _string
}